/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import { Provider, connect } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'

import config from './Core/Config'

/* Core Sagas & Socket Sagas */
import { Reducers, Sagas as coreSagas } from './Core'
import { Sagas as socketSagas } from './Core/Socket'

/* App Setup */
import { Frame } from './containers'
import { ApiCreators, ChatCreators, SocketCreators } from './actions'
import { initTracking } from './Core/Tracking/helpers'
import './App.scss'

const sagaMiddleware = createSagaMiddleware()
const webSocketMiddleware = createSagaMiddleware()

export const store = createStore(Reducers, composeWithDevTools(applyMiddleware(sagaMiddleware, webSocketMiddleware)))

sagaMiddleware.run(coreSagas)
webSocketMiddleware.run(socketSagas)

export class App extends React.Component {
  static propTypes = {
    /* props passed via host app */
    brand: PropTypes.string,
    department: PropTypes.string,
    hidden: PropTypes.bool,
    minimized: PropTypes.bool,
    onEnd: PropTypes.func,
    onMinimized: PropTypes.func,
    onSetCmcStatus: PropTypes.func,
    reset: PropTypes.bool,
    webSocketUrl: PropTypes.string,

    /* props injected via redux state */
    onGetContactCenterStatus: PropTypes.func,
  }

  static defaultProps = {
    brand: 'ARGOS',
    department: 'SERVICE',
    hidden: true,
    minimized: false,
    onMinimized: () => {},
    onEnd: () => {},
    onGetContactCenterStatus: () => {},
    reset: false,
    webSocketUrl: '',
  }

  componentDidMount() {
    const { onGetContactCenterStatus, onSetCmcStatus, brand } = this.props
    initTracking()
    onGetContactCenterStatus(onSetCmcStatus, brand)
  }

  render() {
    const {
      brand,
      contactCenterConnecting,
      contactCenterOnline,
      department,
      hidden,
      minimized,
      onEnd,
      onMinimized,
      reset,
      webSocketUrl,
    } = this.props
    const chatOnline = !contactCenterConnecting && contactCenterOnline
    return (
      chatOnline && <Frame {...{ hidden, minimized, reset, onMinimized, onEnd, brand, department, webSocketUrl }} />
    )
  }
}

const mapStateToProps = (state) => ({
  contactCenterConnecting: state.Api.contactCenterConnecting,
  contactCenterOnline: state.Api.contactCenterOnline,
})

const mapDispatchToProps = (dispatch) => ({
  onGetContactCenterStatus: (next, brand) => dispatch(ApiCreators.contactCenterAttempt(next, brand)),
})

const AppConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(App)

export default (props) => (
  <Provider store={store}>
    <AppConnected {...props} />
  </Provider>
)
